import { LoadingProps } from 'typings'
import { Spinner } from './Loading.style'

export function Loading({ message = 'Carregando...' }: LoadingProps) {
  return (
    <Spinner.Wrapper>
      <Spinner.Icon>
        <span></span>
      </Spinner.Icon>
      <Spinner.Message>
        <span>{message}</span>
      </Spinner.Message>
    </Spinner.Wrapper>
  )
}
